var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    stroke: "white",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M79.823,36.086L72.414,89.199L27.586,89.199L20.177,36.086L79.823,36.086Z",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.727,29.606L19.273,29.606L17.98,20.33L82.02,20.33L80.727,29.606Z",
    style: {
      strokeWidth: 3
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.30368,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9,16.423C66.9,15.704 66.316,15.121 65.597,15.121L41.01,15.121C40.291,15.121 39.708,15.704 39.708,16.423L39.708,19.028C39.708,19.747 40.291,20.33 41.01,20.33L65.597,20.33C66.316,20.33 66.9,19.747 66.9,19.028L66.9,16.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9,16.423C66.9,15.704 66.316,15.121 65.597,15.121L41.01,15.121C40.291,15.121 39.708,15.704 39.708,16.423L39.708,19.028C39.708,19.747 40.291,20.33 41.01,20.33L65.597,20.33C66.316,20.33 66.9,19.747 66.9,19.028L66.9,16.423Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bfbabda1fc32f0b15cb33df6b61901c9.svg";
export { ForwardRef as ReactComponent };